
        var result = require("!!../../../../node_modules/css-loader/index.js!./management-sales-goal.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/management/sales-goal/management-sales-goal.component.css
// module id = 2513
// module chunks = 1